<script lang="ts">
	import type { HTMLTextareaAttributes } from "svelte/elements";
	import { updateTextareaHeight } from "@core/utils/updateTextareaHeight.js";

	const { ...rest }: HTMLTextareaAttributes = $props();
</script>

<textarea
	use:updateTextareaHeight
	{...rest}
	class={[
		"resize-none min-w-0 rounded border shadow-sm border-transparent [&:user-invalid]:border-fstphlox transition-[outline,text,border] duration-300 focus:border-fstgreen focus:[&:user-invalid]:outline-fstgreen outline-transparent outline-1 outline outline-offset-1 p-3 max-h-[none]",
		rest.class,
	]}
></textarea>
